import { Modal, Form, Select, message,Input } from 'antd';
import React, { useState, useEffect } from 'react';
import SPRangePicker from '../../../base/SPRangePicker';
import moment, { Moment } from 'moment';
import { encryptTextByAES, decryptTextByAES } from '../../../../utils/encryption';

import emiter, {
	EVENT_CARRENTAL_VEHICLE_OCCUPYMODAL_OPEN,
	EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH,
	EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH_FROM_SEARCH, EVENT_CARRENTAL_OPEN_SERVICESCOPE_MODAL,
} from '../../../../events';

import request from '../../../../request';
import { API_VEHICLE_OCCUPY_CONFIRM } from '../../../../hooks/carRental/_';

interface props {
	enums?: any;
}


const SPOccupyModal: React.FC<props> = props => {
	const { enums } = props;
	const [occupyOpen, setOccupyOpen] = useState(false);
	const [arrangementOpen, setArrangementOpen] = useState(false);
	const [form] = Form.useForm();
	const [optionType, setOptionType] = useState<any>();
	const [data, setData] = useState<any>();
	const [date, setDate] = useState<any>(null);

	const onOccupyOk = () => {
		request({
			url: API_VEHICLE_OCCUPY_CONFIRM,
			method: 'POST',
			data: {
				veh_code: data.veh_code,
				store_code: data.store_code,
				use_type: optionType,
				start_time: moment(form.getFieldValue('dateRange').start_date).unix(),
				end_time: moment(form.getFieldValue('dateRange').end_date).unix(),
				encrypt_veh_plate:
					data && data.encrypt_veh_plate ? encryptTextByAES(data.encrypt_veh_plate) : undefined,
			},
		}).then((res: any) => {
			if (res.data.occupy_id) {
				message.success('占库成功');
				emiter.emit(EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH_FROM_SEARCH)
				onModalClose();
			}
		});
	};

	const onOccupyCancel = () => {
		onModalClose();
	};

	const onChangeType = (value: any) => {
		setOptionType(value);
	};

	const onModalOpen = (data: any) => {
		setOccupyOpen(true);
		setData(data);
	};

	const onModalClose = () => {
		setOccupyOpen(false);
		form.resetFields();
		setOptionType(undefined);
	};

	const disabledDate: any = (current: any) => {
		if (!date) {
			return current.isBefore(moment(), 'day');
		}
		const tooLate = date[0] && current.diff(date[0], 'days') > 31;
		const tooEarly = date[1] && date[1].diff(current, 'days') > 31;
		return !!tooEarly || !!tooLate || current.isBefore(moment(), 'day');
	};

	const disabledTime = (now: any, partial: any) => {
		if (now) {
			const disabledTime = moment();
			const disabledDay = moment(disabledTime).date();
			const nowDay = moment(now).date();
			if (disabledDay === nowDay) {
				return {
					disabledHours: () => {
						let hours: number[] = [];
						let time: any = moment();
						let hour = moment(time).hour();
						for (let i = 0; i < hour + 1; i++) {
							hours.push(i);
						}
						return hours;
					},
				};
			}
		}
		return {};
	};

	useEffect(() => {
		emiter.on(EVENT_CARRENTAL_VEHICLE_OCCUPYMODAL_OPEN, onModalOpen);
		return () => {
			emiter.removeAllListeners(EVENT_CARRENTAL_VEHICLE_OCCUPYMODAL_OPEN)
		}
	}, []);

	return (
		<>
			<Modal title="车辆占库" open={occupyOpen} onOk={onOccupyOk} onCancel={onOccupyCancel} destroyOnClose={true}>
				<Form form={form} onFinish={onOccupyOk}>
					<Form.Item label="占库类型" name="optionType">
						<Select options={(enums as any).stock_use_type?.filter((item:any)=> item.key == 0)} fieldNames={{ label: 'value', value: 'key' }} onChange={onChangeType} placeholder="请选择占库类型" />
					</Form.Item>
					{optionType == 0 ? (
						<Form.Item label="占用日期" name="dateRange">
							<SPRangePicker
								disabledDate={disabledDate}
								startName="start_date"
								endName="end_date"
								showTime={{ format: 'HH:mm' }}
								format={"YYYY-MM-DD HH:mm"}
								disabledTime={disabledTime}
								onCalendarChange={(val: any,dateStrings:any,info:any) => {
									if (dateStrings[0] == dateStrings[1]) {
										message.error('开始日期和结束日期不能相同');
										return
									} else {
										setDate(val);
									}
								}}
								minuteStep={15}
							></SPRangePicker>
						</Form.Item>
					) : null}
				</Form>
			</Modal>
		</>
	);
};

export default SPOccupyModal;
